const POST_SIGNUP_OVERLAY_KEY = "postSignupOverlay";
const POST_SIGNUP_OVERLAY_EVENT = "postSignupOverlayChanged";

const safeParse = (value) => {
  if (!value) {
    return null;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
};

export const getPostSignupOverlay = () => {
  return safeParse(localStorage.getItem(POST_SIGNUP_OVERLAY_KEY));
};

export const setPostSignupOverlay = (payload) => {
  const data = { ...payload, updatedAt: Date.now() };
  localStorage.setItem(POST_SIGNUP_OVERLAY_KEY, JSON.stringify(data));
  window.dispatchEvent(new Event(POST_SIGNUP_OVERLAY_EVENT));
};

export const clearPostSignupOverlay = () => {
  localStorage.removeItem(POST_SIGNUP_OVERLAY_KEY);
  window.dispatchEvent(new Event(POST_SIGNUP_OVERLAY_EVENT));
};

export { POST_SIGNUP_OVERLAY_EVENT };
